// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeChangeRejectionReason {
  RefundedCharge = "REFUNDED_CHARGE",
  MaximumChangeCountExceeded = "MAXIMUM_CHANGE_COUNT_EXCEEDED",
  InvalidChargeValidityStatus = "INVALID_CHARGE_VALIDITY_STATUS",
  DeniedForChargeType = "DENIED_FOR_CHARGE_TYPE",
}
export default ChargeChangeRejectionReason;
